import BaseUIProductListItem from 'xui/modules/product/BaseUIProductListItem'

export default class ProductListItem extends BaseUIProductListItem {}
